// Client voor de venue-tools functie (repo: feest-functions). Die functie praat
// namens ons met Gemini en de Geocoding API, zodat de Google-sleutels op de
// server blijven in plaats van in deze bundel te belanden.
import { auth } from "./firebase.js";

const BASE_URL =
  process.env.REACT_APP_VENUE_TOOLS_URL || "https://europe-west1-feestjegeven-nl.cloudfunctions.net/venue-tools";

async function post(path, body) {
  const user = auth.currentUser;
  if (!user) throw new Error("Niet ingelogd.");

  const token = await user.getIdToken();
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || "Er ging iets mis.");
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function generateVenueDescription({ venue, currentDescription, improve }) {
  const { text } = await post("/describe", {
    venue: {
      name: venue.name,
      address: { city: venue.address?.city, province: venue.address?.province },
      types: venue.types,
      features: venue.features,
      minCapacity: venue.minCapacity,
      maxCapacity: venue.maxCapacity,
      isB2BOnly: venue.isB2BOnly,
    },
    currentDescription,
    improve,
  });

  return text;
}

// Geeft null terug als het adres niet gevonden is; opslaan gaat dan door zonder
// coördinaten, net als voorheen.
export async function geocodeAddress(address) {
  try {
    const { location } = await post("/geocode", { address });
    return location;
  } catch (err) {
    if (err.status === 404) return null;
    throw err;
  }
}
